// tasarim.js — DÜĞME · SEKME · MENÜ ÖĞESİ TASARIMI — TEK KAYNAK (1 Eki 2026)
//
// 🔑 Serkan (1 Eki 2026, ofis talebi): *"butonlar border (tile) içinde olsun, tuşları net görelim; renkleri biraz
//    ayrışacak bir renk olsun"* → tasarım **B** (çerçeveli kutu + solda renk şeridi) · *"her modülün içinde butonlarda
//    border, aynı tasarımı oraya da uygula"* · *"nihai tasarım … genel olarak güzel"* · daraltılmış menüde *"belirgin
//    renkler"* + *"mantıklı imajlar"* (simgeler: ./simgeler.js).
// 🔴 ÖNCESİ (ölçüldü 1 Eki): 256 düğme / 40 dosya · 117'si satır içi stilli · aynı adlı stil ayrı ayrı tanımlı
//    (btnS ×4, btnP ×3, btnPrimary ×2, btnSecondary ×2) — aynı "kaydet" her ekranda biraz farklıydı.
//
// KURAL: her düğme çerçeveli kutu; soldaki şerit + çerçeve rengi İŞİN TÜRÜNÜ söyler — birincil (asıl iş) mavi ·
//    nötr gri · dikkat (geri alınabilir ama dikkat) turuncu · silme (geri dönüşsüz) kırmızı. Menüde renk MODÜLÜN
//    GRUBUNU söyler. Renkler tema değişkenlerinden — açık temada kendiliğinden doğru.

export const ROL_RENGI = {
  birincil: 'var(--accent)',
  notr:     'var(--t3)',
  dikkat:   'var(--orange)',
  silme:    'var(--red)',
};

export const GRUP_RENGI = {
  ucus:   'var(--accent)',   // FLT OPS · Archived FLTs · FLTs Logs & Times
  filo:   'var(--amber)',    // Aircrafts · RAAQ
  ekip:   'var(--green)',    // Crews & Officers · Legal Ops & Crew Control
  rapor:  'var(--violet)',   // Statistics · Ops Calculator · Edit Reports
  yardim: 'var(--t3)',       // FAQ & Help
};

/** Üzerine gelince hafif aydınlatma — satır içi arka planı ezmeden (App.css `.go2-kutu`). */
export const KUTU_SINIFI = 'go2-kutu';

const serit = (renk) => `inset 4px 0 0 0 ${renk}`;

/** Düğme: rol = birincil | notr | dikkat | silme. Asıl iş kalın çerçeveli ve hafif dolu. */
export function dugmeStili(istenen = 'notr', { kucuk = false, devreDisi = false } = {}) {
  const rol = ROL_RENGI[istenen] ? istenen : 'notr';     // tanınmayan rol TAM nötr olur (yarım renk değil)
  const renk = ROL_RENGI[rol];
  const birincil = rol === 'birincil';
  return {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    padding: kucuk ? '5px 10px 5px 12px' : '8px 14px 8px 16px', borderRadius: 8,
    fontFamily: 'var(--mono)', fontSize: kucuk ? 11 : 12, fontWeight: 700, letterSpacing: 1,
    textTransform: 'uppercase', whiteSpace: 'nowrap', cursor: devreDisi ? 'not-allowed' : 'pointer',
    background: birincil ? 'var(--accent-soft)' : 'var(--bg3)',
    border: birincil ? `2px solid ${renk}` : `1px solid ${rol === 'notr' ? 'var(--border2)' : renk}`,
    color: rol === 'notr' ? 'var(--t1)' : renk,
    boxShadow: serit(renk),
    opacity: devreDisi ? 0.45 : 1,
  };
}

/** Sekme (ör. View Activity panelinde DETAILS · TIMELINE): seçili = birincil, öteki = nötr kutu, ikisinin şeridi de mavi. */
export function sekmeStili(secili) {
  return { ...dugmeStili(secili ? 'birincil' : 'notr'), boxShadow: serit(GRUP_RENGI.ucus),
           color: secili ? 'var(--accent)' : 'var(--t2)' };
}

/** GÖRÜNÜM DÜĞMESİ — göster/gizle (HIDE / SHOW …) — TEK KAYNAK (5 Eki 2026).
 *  🔑 Serkan (5 Eki 2026): *"bütün hide tuşları ve bugün yaptığımız show tuşu belli olmuyor, onları da border içinde
 *     belirgin yapalım"* → tasarım **B** onaylı: *"bunu uygulama içindeki bütün hide show gibi belirsizlik arz eden
 *     düğmelere yapalım"*. Nötr küçük kutu + MAVİ şerit + mavi yazı (FLT OPS sekmesinin ailesi): bir GÖRÜNÜM
 *     değişikliğidir, asıl iş (birincil) değil. Ok işareti `GosterGizle` bileşeninde (▾ açık · ▸ kapalı).
 *  🔴 Önce: 9 px, soluk gri yazı, ince gri çizgi — ekranda seçilmiyordu (FTL LIMITS, FCL LIMITS, DUTY SHEET NOTES). */
export function gorunumDugmesiStili() {
  return { ...dugmeStili('notr', { kucuk: true }), gap: 6, color: 'var(--accent)', boxShadow: serit('var(--accent)') };
}
/** AÇILIR BAŞLIK — tasarım **Y** (Serkan 5 Eki 2026: *"butonlar switchler hepsi belirgin ve border içinde olsun"*): başlığın
 *  TAMAMI çerçeveli kutu + mavi şerit; açıkken kenar mavi (hangi bölüm açık uzaktan görünür); sağda görünüm düğmesi.
 *  🔴 Önce: solda +/−, sağda soluk v/^ ya da ▲▼ — kural blokları, ARCHIVED FLTS kutuları, RAAQ. Bileşen `AcilirBaslik`. */
export function acilirBaslikStili(acik) {
  return {
    display: 'flex', alignItems: 'center', gap: 10, width: '100%', boxSizing: 'border-box',
    padding: '8px 10px 8px 16px', borderRadius: 8, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
    background: 'var(--bg2)', color: 'var(--t1)', border: `1px solid ${acik ? 'var(--accent)' : 'var(--border2)'}`,
    boxShadow: serit('var(--accent)'),
  };
}
/** SEÇİM KUTUSU (switch) — tasarım **S1** (Serkan 5 Eki 2026): çerçeveli nötr kutu + mavi şerit + işaret kutusu (✓);
 *  işaretliyken kenar mavi. 🔴 Önce: çıplak tarayıcı kutusu (OPS CALCULATOR, SYSTEM MONITORING). Bileşen `SecimKutusu`. */
export function secimKutusuStili(isaretli, devreDisi = false) {
  return { ...dugmeStili('notr', { kucuk: true, devreDisi }), gap: 8, color: 'var(--t1)', boxShadow: serit('var(--accent)'),
           border: `1px solid ${isaretli ? 'var(--accent)' : 'var(--border2)'}` };
}
/** ZORUNLU ALAN ÇERÇEVESİ — iPad'in aynısı (Serkan 2 Eki 2026 **A**: *"save edebilmek için gereken min entry boşken …
 *  doldurulunca …, iOS ile aynı mantık; bazen gözden kaçıyor, save edemiyor kullanıcılar"* · 5 Eki: *"ipad le ayni evet"*):
 *  zorunlu ve BOŞ alan 1.5px AMBER, doldurulunca 1.5px MAVİ (vurgu), zorunlu değilse dokunulmaz.
 *  🔑 Renk ayrı bir listeden gelmez (iPad `PreArchiveCheck.cellState`): çağıran, kaydetme kapısının KENDİ koşulunu verir —
 *  renk ile kapı ayrışamaz. Dönen nesne alanın style'ına yayılır; `data-zorunlu` testler ve denetim içindir.
 *  @param zorunlu kapı bu alanı şu an istiyor mu · @param dolu kapının kendi geçerlilik ölçüsüyle dolu mu */
export function zorunluAlan(zorunlu, dolu) {
  if (!zorunlu) return { style: {}, 'data-zorunlu': undefined };
  return { style: { border: `1.5px solid ${dolu ? 'var(--accent)' : 'var(--amber)'}` }, 'data-zorunlu': dolu ? 'dolu' : 'eksik' };
}

/** Taban stil + zorunlu alan kuralı tek yayılımda — alana `{...zAlan(S.input, zorunlu, dolu)}` (style + data-zorunlu).
 *  FTL ve admin panelleri AYNI yardımcıyı kullanır (5 Eki 2026). */
export const zAlan = (taban, zorunlu, dolu) => {
  const z = zorunluAlan(zorunlu, dolu);
  return { style: { ...taban, ...z.style }, 'data-zorunlu': z['data-zorunlu'] };
};

/** ALAN LİSTESİ KAPISI (5 Eki 2026) — formun zorunlu alanları sırasıyla `{ alan, zorunlu, gecerli, mesaj }`. Kapı ilk
 *  geçersiz zorunlu alanın cümlesini söyler (`ilkEksik`); zorunlu alan rengi AYNI listeden okunur (`listedenAlan`) —
 *  bir alanın birden çok satırı olabilir (ICAO biçimi + listede yok), hepsi geçerliyse mavi. */
export const ilkEksik = (liste) => (liste || []).find(x => x.zorunlu && !x.gecerli)?.mesaj || null;
export const listedenAlan = (liste, alan, taban) => {
  const s = (liste || []).filter(x => x.alan === alan && x.zorunlu);
  return zAlan(taban, s.length > 0, s.every(x => x.gecerli));
};

/** Aynı stil CSS metni olarak — DUTY SHEET çizelgesi HTML/CSS metniyle çizilir (ekran + baskı tek kaynak). */
const BIRIMSIZ = new Set(['fontWeight', 'opacity', 'lineHeight', 'zIndex', 'flex']);
export const GORUNUM_DUGMESI_CSS = Object.entries(gorunumDugmesiStili())
  .map(([k, v]) => `${k.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`)}:${typeof v === 'number' && !BIRIMSIZ.has(k) ? `${v}px` : v}`)
  .join(';');

/** Sekme çubuğu (kapsayıcı) — LEGAL OPS & CREW CONTROL, FLTs Logs & Times ve View Activity panelleri AYNI çubuk
 *  (1 Eki 2026, Serkan: "bu modüldeki butonlar değişmemiş"). Dar ekranda alt satıra kayar. */
export const SEKME_CUBUGU = {
  display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, padding: '10px 16px',
  borderBottom: '1px solid var(--border)', background: 'var(--bg2)',
};

/** Açık menü öğesi: kutu + grup rengi şerit; seçili olan mavi kalın çerçeve. */
export function menuOgesiStili(grup, secili) {
  const renk = GRUP_RENGI[grup] || GRUP_RENGI.yardim;
  return {
    display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px 8px 13px', margin: '0 0 6px',
    borderRadius: 8, cursor: 'pointer',
    background: secili ? 'var(--accent-soft)' : 'var(--bg3)',
    border: secili ? '2px solid var(--accent)' : '1px solid var(--border2)',
    boxShadow: serit(renk),
  };
}

/** Daraltılmış menü karesi: simge grup renginde, altta grup rengi şerit (Serkan'ın onayladığı B). */
export function menuKaresiStili(grup, secili) {
  const renk = GRUP_RENGI[grup] || GRUP_RENGI.yardim;
  return {
    width: 40, height: 40, margin: '0 auto 7px', borderRadius: 8, cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: secili ? 'var(--accent-soft)' : 'var(--bg3)',
    border: secili ? '2px solid var(--accent)' : '1px solid var(--border2)',
    boxShadow: `inset 0 -4px 0 0 ${renk}`,
    color: renk,
  };
}

/** Menü öğesinin simge rengi (açık menüde de grup renginde). */
export const grupRengi = (grup) => GRUP_RENGI[grup] || GRUP_RENGI.yardim;

/** Sol sütunun altı: COLLAPSE (mavi) ve LOGOUT (kırmızı) — DİKKAT ÇEKİCİ (Serkan 1 Eki 2026: "logout butonu ve
 *  collapse de dikkat çekici olsun — ana sol sütunda"). Kalın çerçeve + hafif dolgu; dar = daraltılmış menü (kare). */
export function sutunDugmesiStili(tur, dar) {
  const cikis = tur === 'cikis';
  const renk = cikis ? 'var(--red)' : 'var(--accent)';
  const ortak = {
    border: `2px solid ${renk}`, background: cikis ? 'var(--red-soft)' : 'var(--accent-soft)', color: renk,
    borderRadius: 8, cursor: 'pointer', fontFamily: 'var(--mono)', fontWeight: 700, letterSpacing: 1,
    display: 'flex', alignItems: 'center',
  };
  return dar
    ? { ...ortak, width: 40, height: 40, margin: '0 auto 8px', padding: 0, justifyContent: 'center', fontSize: 18 }
    : { ...ortak, width: '100%', gap: 10, padding: '9px 12px', marginBottom: 8, justifyContent: 'flex-start', fontSize: 12 };
}
